import axios from "../utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createAsset = createAsyncThunk(
  "assetAndPromotion",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("assetAndPromotion", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getAssets = createAsyncThunk(
  "getAssetAndPromotion",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(
        `assetAndPromotion?page=${payload?.page}&limit=${payload?.limit || 10}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const toggleAssetStatus = createAsyncThunk(
  "assetAndPromotion/status",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.patch(
        `assetAndPromotion/status/${payload?.id}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const editAsset = createAsyncThunk(
  "assetAndPromotion/update",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.patch(`assetAndPromotion/${payload?.id}`, payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const deleteAsset = createAsyncThunk(
  "assetAndPromotion/delete",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.delete(`assetAndPromotion/${payload?.id}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const removeFundraiserFromPromotion = createAsyncThunk(
  "assets/removeFundraiser",
  async ({ promotionId, fundraiserId }, thunkAPI) => {
    try {
      const response = await axios.delete(
        `assetAndPromotion/fundraiser/${promotionId}/${fundraiserId}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getMyAssets = async () => {
  try {
    const response = await axios.get("assetAndPromotion/my-assets");
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAssetDetails = async (assetId) => {
  try {
    const response = await axios.get(`assetAndPromotion/details/${assetId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Admin-safe: fetch asset/promotion by id (basic document fetch)
export const getAssetById = createAsyncThunk(
  "assetAndPromotion/getById",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(`assetAndPromotion/${payload?.id}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);